var ContentModule = /** @class */ (function () {
    function ContentModule() {
    }
    return ContentModule;
}());
export { ContentModule };
